// extracted by mini-css-extract-plugin
export default {"markdownContent":"MarkdownStyles_markdownContent__FFbT4"};